export const environment = {
  production: true,
  apiUrl: 'https://reach-ecomm-api-new.fayastage.com/api/v1/ecommerce/',
  authUrl: 'https://reach-ecomm-api-new.fayastage.com/oauth2',
  clientId: 'pFNmDJpWCWQvH1NYVyHWgz9SdqLL3sDPDw5Fuh5H',
  clientSecret: 'YST5Hl8jgbrHqBnvh0CzBSeXIbw89wGn0tqpWUDGIiBk1nWmsMluvcSrjTmmMDCA97IjpuP74YJAadBsDhHtODc1aB5DgMCzmYbRFwhA5RcRekMOgFUzGc57OeE522pD',
  tableRowLimit: '15',
};
